var map = {
	"./advising.jpg": "o+p8",
	"./aware.jpg": "gaAv",
	"./certificate.jpg": "3qJl",
	"./cry.jpg": "pFFJ",
	"./dad-kid.jpg": "PZup",
	"./group.jpg": "HzNl",
	"./happy-doc.jpg": "u9fR",
	"./hussle.jpg": "NulR",
	"./line.jpg": "2Z8I",
	"./muslim-2.jpg": "ZwXt",
	"./old-doc.jpg": "syno",
	"./patients.jpg": "6iiC",
	"./ranjana.jpg": "ulPN",
	"./room.jpg": "owuG",
	"./sign-2.jpg": "tUis",
	"./team-2.jpg": "68Zu",
	"./team.jpg": "Enlp",
	"./tika.jpg": "bgrt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G6Xb";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/IndraDhanush/IndraDhanush-pics ^\.\/.*$
// module id = G6Xb
// module chunks = 0